import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, catchError, exhaustMap, from, tap } from 'rxjs';
import { EStorageKeys } from '@app/app.enums';
import { KeycloakSessionService } from '@core/services/auth/keycloak-session.service';
import { localReturnPath } from '@core/config/runtime-config';
import { ToastService } from 'mt-ui-lib/services/toast';
import { AuthActions } from './auth.actions';

@Injectable()
export class AuthEffects {
  private readonly actions$ = inject(Actions);
  private readonly session = inject(KeycloakSessionService);
  private readonly router = inject(Router);
  private readonly toast = inject(ToastService);

  readonly logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.logout),
        exhaustMap(({ returnPath }) =>
          from(this.session.logout(returnPath)).pipe(
            catchError(() => {
              void this.toast.add({
                level: 'error',
                summary: 'Не удалось завершить сеанс. Повторите выход.',
              });
              return EMPTY;
            }),
          ),
        ),
      ),
    { dispatch: false },
  );

  readonly sessionEnded$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.sessionEnded),
        tap(() => this.router.navigate(['/auth'])),
      ),
    { dispatch: false },
  );

  readonly favorite$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.setFavoriteUrl),
        tap(({ favoriteUrl }) => {
          const path = localReturnPath(favoriteUrl, location.origin);
          if (path)
            localStorage.setItem(
              EStorageKeys.MENU_FAVORITE,
              JSON.stringify(path),
            );
          else localStorage.removeItem(EStorageKeys.MENU_FAVORITE);
        }),
      ),
    { dispatch: false },
  );
}
